export enum EmployerBrand {
  HEALTHNOW = "HEALTHNOW",
  EXTRAORDINARY = "EXTRAORDINARY"
}
